import { observer } from 'mobx-react-lite';
import PivotTablejs from './PivotTablejs';
import { store, useStore } from '../../app/stores/store';
import { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Form,
  Header,
  Progress,
  Segment,
  Table,
} from 'semantic-ui-react';
import PivotSmallModal from './PivotSmallModal';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import UnauthorizedMessage from '../UnauthorizedMessage';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { useNavigate } from 'react-router-dom';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
 
function PivotTableMain() {
  const { PivotStore, commonStore, dashboardStore } = useStore();
  const history = useNavigate();
  const {
    loadPivotReportkeys,
    setChosenMetaData,
    saveChosenPivotData,
    chosenPivotReportKeys,
    getPivotReportKeys,
    setInitialData,
    mainPivotData,
    showPivotReport,
    pivotReportModal,
    setPivotRowandColumn,
    loadCheckBox,
    loadPivotTable,
    totalPivotCount,
    progressCount,
    dateFormat,
  } = PivotStore;
  const [pivotKeysData, setPivotKeysData] = useState<string[]>([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setendDate] = useState('');
 
  useEffect(() => {
    setPivotKeysData([]);
    setInitialData();
    PivotStore.chosenPivotReportKeys = [];
    // eslint-disable-next-line
  }, []);
 
  useEffect(() => {
    if (startDate !== '' && endDate !== '') {
      loadPivotReportkeys(dateFormat(startDate), dateFormat(endDate));
    }
    // eslint-disable-next-line
  }, [startDate, endDate]);
 
  const setDate = (data: any, type: string) => {
    try {
      if (type === 'start') {
        setStartDate(data);
      } else {
        setendDate(data);
      }
    } catch (error) {
      console.error('Error', error);
    }
  };
 
  useEffect(() => {
    setPivotKeysData(getPivotReportKeys);
  }, [getPivotReportKeys]);
 
  if (loadCheckBox || loadPivotTable)
    return (
      <Segment style={{ margin: '27rem 27rem 0rem 27rem' }}>
        <Progress
          style={{ marginTop: '20px' }}
          indicating
          value={progressCount}
          total={totalPivotCount}
          percent={Math.ceil(progressCount)}
          progress
        >
          {
            (userLanguage[0].SBPivotTableMain.SBPTM04 as any)?.[
              `${commonStore.language.key}`
            ]
          }{' '}
        </Progress>
      </Segment>
    );
  return (
    <>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('RPTB01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne.includes('RPTB01') && (
        <div style={{ padding: '1px' }}>
          {pivotReportModal && (
            <PivotSmallModal startDate={startDate} endDate={endDate} />
          )}
          <Header
            style={{ marginLeft: '20px' }}
            icon="cogs"
            size="huge"
            dividing
            as="h1"
            content={
              (userLanguage[0].Sidebar.M10I02 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            sub
            color="grey"
          />
          <h1 style={{ marginLeft: '20px', marginTop: '20px' }}>
            {
              (userLanguage[0].SBPivotTableMain.SBPTM01 as any
              )?.[`${commonStore.language.key}`]
            }
          </h1>
          <div
            style={{
              display: 'flex',
              marginTop: '10px',
              position: 'relative',
            }}
          >
            {commonStore.filterModeTwo?.includes('PTGR01') ? (
              <></>
            ) : (
              !showPivotReport &&
              pivotKeysData.length > 0 && (
                <Button
                  primary
                  onClick={() =>
                    saveChosenPivotData(
                      PivotStore.dateFormat(startDate),
                      PivotStore.dateFormat(endDate),
                      1,
                      100,
                    )
                  }
                  disabled={commonStore.filterModeZero?.includes('PTGR01')}
                  style={{
                    position: 'absolute',
                    right: '20px',
                    bottom: '0px',
                  }}
                >
                  {
                    (userLanguage[0].SBPivotTableMain.SBPTM05 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Button>
              )
            )}
 
            {/* {!showPivotReport&&pivotKeysData.length>0
 &&<Button primary
  onClick={()=>saveChosenPivotData(PivotStore.dateFormat(startDate),PivotStore.dateFormat(endDate),1,100)}
 style={{ position:"absolute",right:"20px", bottom:"0px" }}>Generate Report</Button>
  } */}
            <Form.Field required={true}>
              <label style={{ marginLeft: '90px' }}>
                <b>{
                  (userLanguage[0].SBPivotTableMain.SBPTM02 as any)?.[
                    `${commonStore.language.key}`
                  ]
                 }</b>
              </label>
              <br />
              <div style={{ position: 'relative' }}>
                <DatePicker
                  value={startDate ? PivotStore.dateFormat(startDate) : ''}
                  className="date-picker-style"
                  showMonthDropdown
                  showYearDropdown
                  locale={'en'}
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={15}
                  maxDate={moment().toDate()}
                  scrollableYearDropdown
                  onChange={(date: any) => setDate(date, 'start')}
                  popperProps={{ strategy: 'fixed' }}
                />
              </div>
            </Form.Field>
            <Form.Field required={true}>
              <label style={{ marginLeft: '100px' }}>
                <b>{
                  (userLanguage[0].SBPivotTableMain.SBPTM03 as any)?.[
                    `${commonStore.language.key}`
                  ]
                  }</b>
              </label>
              <br />
              <div style={{ position: 'relative' }}>
                <DatePicker
                  value={endDate ? PivotStore.dateFormat(endDate) : ''}
                  showMonthDropdown
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  locale={'en'}
                  className="date-picker-style"
                  yearDropdownItemNumber={15}
                  maxDate={moment().toDate()}
                  scrollableYearDropdown
                  onChange={(date: any) => setDate(date, 'end')}
                  popperProps={{ strategy: 'fixed' }}
                />
              </div>
            </Form.Field>
          </div>
          {!showPivotReport && pivotKeysData.length > 0 && (
            <Segment style={{ margin: '16px 20px' }}>
              <Segment style={{ height: '47rem', overflowY: 'scroll' }}>
                <Table basic>
                  <Table.Body>
                    {pivotKeysData?.map((label) => {
                      return (
                        <Table.Row>
                          <Table.Cell>
                            <Checkbox
                              label={label}
                              onChange={(e, data) => setChosenMetaData(data)}
                              defaultChecked={
                                chosenPivotReportKeys.includes(label)
                                  ? true
                                  : false
                              }
                            />
                          </Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                </Table>
              </Segment>
            </Segment>
          )}
          {showPivotReport && (
            <>
              <Button
                primary
                floated="right"
                style={{
                  position: 'absolute',
                  right: '20px',
                  top: '124px',
                }}
                onClick={() => PivotStore.setOpenPivotReportModal(true)}
              >
                {
                  (userLanguage[0].SBPivotTableMain.SBPTM06 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </Button>
              <div style={{ marginTop: '40px' }}>
                <PivotTablejs
                  activitiesByDate={mainPivotData}
                  setPivotRowandColumn={setPivotRowandColumn}
                  rows={[]}
                  cols={[]}
                  redirectData={(myId: string) =>
                    history(`/mediaAssets/${myId}`)
                  }
                  customer={store.userStore.user?.customerName}
                  chosenPivotReportKeys={PivotStore.chosenPivotReportKeys}
                />
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
 
export default observer(PivotTableMain);